import {RelayPositionValues, relayPositionFields} from './RelayPositions';
import * as React from 'react';
import { Component } from 'react';
import { History, Location } from 'history';
import propz from 'propz';
import { parse } from 'query-string';
import { AppUser } from 'Src/views/App/App';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE } from 'Src/consts/table';
import { CELL_ACTION_ICON } from 'Src/consts/cell';
import { Grid2 } from 'Src/components/Grid/Grid2';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { Checkbox } from 'Src/components/Checkbox/Checkbox';
import { Loader } from 'Src/components/Loader/Loader';
import { Switch } from 'Src/components/Switch/Switch';
import { SchoolEvent } from 'Src/models/event';
import { SchoolEventIndividualData } from 'Src/models/event';
import { Tournament } from 'Src/models/tournament';
import { TournamentTeam } from 'Src/models/tournamentTeam';
import { SchoolForm } from 'Src/models/form';
import { IndividualTournamentTeamPlayer } from 'Src/models/tournamentTeamPlayer';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import {
  getAllSchoolUnionHighLevelTournamentEvents,
  getSchoolUnionHighLevelTournamentEvents,
  getSchoolUnionHighLevelTournamentEventsCount
} from 'Src/helpers/service/adminSU/tournamentEventsTable';
import {
  getSelectOptionForAge,
  getSelectOptionForSport,
  getSelectOptionForTournamentEventGender
} from 'Src/helpers/table/select';
import {
  removeSchoolEventIndividualPlayer,
  removeSchoolEventTeamPlayer
} from 'Src/helpers/service/admin/tournamentTeams';
import { updateSchoolEventIndividualsBatch } from 'Src/helpers/service/admin/schoolEventIndividuals';
import { updateSchoolEventTeamPlayersBatch } from 'Src/helpers/service/admin/event';
import { addSchoolEventTeam } from 'Src/helpers/service/admin/tournamentTeams';
import { getSchoolTournamentTeams } from 'Src/helpers/service/admin/tournamentTeams';
import { getAllForms } from 'Src/helpers/service/admin/forms';
import { getSchoolEvent } from 'Src/helpers/service/admin/event';
import { getTournament } from 'Src/helpers/service/adminSU/tournamentsTable';
import { highLevelApi } from 'Src/helpers/service/adminSU/highLevelTournament';
import { getOrder, getSearchFilter, getSearchOrder, getServerFieldSectionWhere } from 'Src/helpers/table/table';
import {
  getEventGeneratedName,
  getEventSportName,
  getAgesGroupFormatted,
  getAllowedGender
} from 'Src/helpers/accessor/accessor';
import { getFullName } from 'Src/helpers/autocomplete/autocomplete';
import { StudentsToAddToEventForm } from './StudentsToAddToEventForm';
import { EventParticipants } from './EventParticipants/EventParticipants';
import '../../../AdminView/Invites/SchoolInvitesHub.scss';
import './HighLevelTournamentEvents.scss';

interface Props {
  user: AppUser;
  history: History;
  location: Location;
  participationReadOnly?: boolean;
  participationTournament?: Tournament;
}

interface State {
  items: SchoolEvent[];
  allEvents: SchoolEvent[];
  teams: TournamentTeam[];
  forms: SchoolForm[];
  currentEvent: SchoolEvent | undefined;
  currentPage: number;
  selectedItems: SchoolEvent[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  filters: any;
  isDataFiltered: boolean;
  total: number;
  basePath: string;
  isSelectAllChecked: boolean;
  tournament: Tournament | undefined;
  modalText: string;
  removeParticipantId: string;
  isStudentsToAddToEventModalOpen: boolean;
  isRemovePlayerFromEventConfirmationModalOpen: boolean;
  isAskToRemovePlayerFromEvent: boolean;
  isLoading: boolean;
  isSavingAllocations: boolean;

  isEditPositionsOpen: boolean;
  positionsEvent?: SchoolEvent;
  positionsDraft: Array<{
    playerId: string;
    userId: string;
    permissionId?: string;
    teamId?: string | null;
    name: string;
    schoolName?: string;
    positionId: string | '';
    isCaptain: boolean;
    isSub: boolean;
  }>;
  positionOptions: Array<{ id: string; label: string }>;
  isSavingPositions: boolean;
}

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Event Name',
    field: 'eventName',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getEventGeneratedName
  },
  {
    text: 'Sport',
    field: 'eventSport',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getEventSportName
  },
  {
    text: 'Ages',
    field: 'eventAges',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getAgesGroupFormatted
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getAllowedGender
  }
];

export class HighLevelTournamentEvents extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      allEvents: [],
      teams: [],
      forms: [],
      currentEvent: undefined,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isSelectAllChecked: false,
      currentPage: FIRST_PAGE,
      total: 0,
      tournament: undefined,
      basePath: '',
      modalText: '',
      removeParticipantId: '',
      isStudentsToAddToEventModalOpen: false,
      isRemovePlayerFromEventConfirmationModalOpen: false,
      isAskToRemovePlayerFromEvent: false,
      isSavingAllocations: false,
      isLoading: false,

      isEditPositionsOpen: false,
      positionsEvent: undefined,
      positionsDraft: [],
      positionOptions: [],
      isSavingPositions: false
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.setAdditionalItems().then(res => {
      this.setItems();
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems(nextProps);
    }
  }

  getTournamentId(props: Props = this.props): string {
    const { history } = props;
    const search = parse(history.location.search);
    const tournamentId = search.tournamentId;
    return tournamentId;
  }

  setAdditionalItems() {
    const { user } = this.props;

    const tournamentId = this.getTournamentId();

    return Promise.all([this.props.participationTournament ? Promise.resolve(this.props.participationTournament) : getTournament(user, tournamentId), highLevelApi(user, tournamentId, 'eventOptions'),
      getSchoolTournamentTeams(user, tournamentId), getAllForms(user)]).then(([tournament, sports, teams, forms]) => {
      this.setState({
        tournament, teams, forms, allEvents: (sports || []).map(sport => ({sport: {...sport, id: sport.id || sport._id}}))
      });

      return true;
    });
  }

  setItems(props: Props = this.props) {
    const { history, user } = props;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(COLUMNS, search);

    const isShowFilter = false;
    const isDataFiltered = isFilterExist2(filters);

    const where = getServerFieldSectionWhere(filters);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const tournamentId = this.getTournamentId(props);

    const getItemsPromise = getSchoolUnionHighLevelTournamentEvents(user, tournamentId, serverQueryFilter);
    const getItemsCountPromise = getSchoolUnionHighLevelTournamentEventsCount(user, tournamentId, where);
    return Promise.all([getItemsPromise, getItemsCountPromise]).then(([items, countObj]) => {
      this.setState({
        items,
        sortDirection,
        sortColumnsName,
        isShowFilter,
        isDataFiltered,
        filters,
        currentPage: page,
        total: countObj.count,
        basePath: history.location.pathname,
        isLoading: false
      });

      return true;
    });
  }

  onItemClick = (index: number): void => {
    if (this.isReadOnly()) return;
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated
    });
  };

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;
    const { history } = this.props;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const tournamentId = this.getTournamentId();

    this.props.history.push({
      pathname: this.state.basePath,
      search: `tournamentId=${tournamentId}&${search.join('&')}`,
      state: history.location.state
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: nextSelectedItems,
      isSelectAllChecked: true
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters);

    const tournamentId = this.getTournamentId();

    getAllSchoolUnionHighLevelTournamentEvents(user, tournamentId, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const nextSelectedItems = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: nextSelectedItems,
        isSelectAllChecked: true,
        isLoading: false
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;
    const { history } = this.props;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const tournamentId = this.getTournamentId();

    this.props.history.push({
      pathname: this.state.basePath,
      search: `tournamentId=${tournamentId}&${search.join('&')}`,
      state: history.location.state
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      if (!filter) return;
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value: string[] = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    const { history } = this.props;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });

    const tournamentId = this.getTournamentId();

    this.props.history.push({
      pathname: this.state.basePath,
      search: `tournamentId=${tournamentId}&${search.join('&')}`,
      state: history.location.state
    });
  };

  onClearFilterClick = (): void => {
    const { history } = this.props;
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });

    const tournamentId = this.getTournamentId();

    this.props.history.push({
      pathname: this.state.basePath,
      search: `tournamentId=${tournamentId}`,
      state: history.location.state
    });
  };

  onCellIconClick = (
    data: {
      currentEvent: SchoolEvent;
      currentParticipant?: SchoolEventIndividualData;
    },
    cell: string
  ) => {
    if (this.isReadOnly()) return;
    const { isAskToRemovePlayerFromEvent } = this.state;
    const { currentEvent, currentParticipant } = data;

    switch (true) {
      case cell === CELL_ACTION_ICON.ADD_TO_EVENT: {
        this.setState({
          currentEvent
        });

        this.openStudentsToAddToEventModal();

        break;
      }

      case cell === CELL_ACTION_ICON.REMOVE_FROM_EVENT: {
        if (!currentParticipant) break;

        const eventName = propz.get(currentEvent, ['generatedNames', 'official'], '');
        const { userId: removeParticipantId } = currentParticipant;
        const playerFullName = getFullName(currentParticipant);

        this.setState(
          {
            modalText: `${playerFullName} will be removed from ${eventName}. Are you sure?`,
            removeParticipantId,
            currentEvent
          },
          () => {
            isAskToRemovePlayerFromEvent
              ? this.removePlayerFromEvent()
              : this.openRemovePlayerFromEventConfirmationModal();
          }
        );
        break;
      }
      case cell === CELL_ACTION_ICON.EDIT_POSITIONS: {
        this.openEditPositions(currentEvent);
        break;
      }
    }
  };

  onCancelFilterClick = (): void => {
    this.setState({ isShowFilter: false, filters: getFilters2(COLUMNS, parse(this.props.history.location.search)) });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter
    });
  };

  goBack = () => {
    const { history, location } = this.props;
    const { state } = location;
    const { search, prevPath } = (state || {}) as any;
    const tournamentId = this.getTournamentId();

    history.push({
      pathname: prevPath || '/highLevelTournaments/upcoming',
      search: search,
      state: { tournamentId: tournamentId }
    });
  };

  addStudentsToEvent = (
    events: SchoolEvent[],
    students: IndividualTournamentTeamPlayer[],
    playersToReplace: { eventId: string; playerId: string }[],
    positions: RelayPositionValues = {}
  ): void => {
    if (this.state.isSavingAllocations) return;
    this.setState({ isLoading: true, isSavingAllocations: true });

    const { user } = this.props;
	const submitWithLimitOverride = (submit: (override: boolean) => Promise<any>) =>
	  submit(false).catch(error => {
	    const text = propz.get(error, ['response', 'data', 'details', 'text'], '');
	    if (text.indexOf('organising union may override') !== -1 && window.confirm(
	      `WARNING\n\n${text}\n\nDo you want to make this exceptional entry?`
	    )) return submit(true);
	    throw error;
	  });

    const removePromises = playersToReplace.filter(row => !propz.get(events.find(event => event.id === row.eventId), ['sport', 'isRelay'], false)).map(({ eventId, playerId }) =>
      removeSchoolEventIndividualPlayer(user, eventId, playerId)
    );

    const addJobs = events.map(event => () => {
      const { id: eventId, ages, gender } = event;
      const studentData = students.map(student => ({
        permissionId: student.permissionId,
        userId: student.userId,
        ...relayPositionFields(event, student, positions[event.id])
      }));

      const isRelay = propz.get(event, ['sport', 'isRelay'], false);

      if (isRelay) {
        const teamsData = propz.get(event, ['teamsData'], []);
        const schoolTeam = teamsData.find(team => String(team.schoolId) === String(user.activeSchoolId));
        const isSchoolTeamExist = typeof schoolTeam !== 'undefined';
        const teamToAdd = { ages, gender, players: studentData };

        return isSchoolTeamExist
		  ? submitWithLimitOverride(override => updateSchoolEventTeamPlayersBatch(user, eventId, schoolTeam.id, { add: studentData, ...(playersToReplace.some(row => row.eventId === eventId) ? {remove: playersToReplace.filter(row => row.eventId === eventId).map(row => row.playerId)} : {}) }, override))
		  : submitWithLimitOverride(override => addSchoolEventTeam(user, eventId, teamToAdd, override));
      } else {
		return submitWithLimitOverride(override => updateSchoolEventIndividualsBatch(user, eventId, { add: studentData }, override));
      }
    });

    Promise.all(removePromises)
      .then(async () => {for (const add of addJobs) await add();})
      .then(() => this.setItems())
      .then(() => {
        this.setState({
          isLoading: false,
          isSavingAllocations: false,
          isStudentsToAddToEventModalOpen: false,
          currentEvent: undefined,
          selectedItems: []
        });
	  })
	  .catch(error => {
		this.setState({ isLoading: false, isSavingAllocations: false });
		window.alert(propz.get(error, ['response', 'data', 'details', 'text'], 'The students could not be added. Please try again.'));
	  });
  };

  removePlayerFromEvent = () => {
    const { user } = this.props;
    const { currentEvent, removeParticipantId } = this.state;

    if (!currentEvent) return;

    const removeEventId = currentEvent.id;

    this.setState({ isLoading: true });

    getSchoolEvent(user, removeEventId)
      .then(schoolEvent => {
        const { players } = schoolEvent;
        const currentPlayer = players.find(player => player.userId === removeParticipantId);

        if (!currentPlayer) return Promise.reject('Player not found');

        const teamId = (currentPlayer as any).teamId;
        const playerId = (currentPlayer as any)._id;
        const isRelay = propz.get(schoolEvent, ['sport', 'isRelay'], false);

        return isRelay
          ? removeSchoolEventTeamPlayer(user, removeEventId, teamId, playerId)
          : removeSchoolEventIndividualPlayer(user, removeEventId, playerId);
      })
      .then(() => this.setItems())
      .then(() => {
        const { items, selectedItems } = this.state;

        const updatedSelectedItems = items.filter(item =>
          selectedItems.some(selectedItem => selectedItem.id === item.id)
        );

        this.setState({
          selectedItems: updatedSelectedItems,
          isRemovePlayerFromEventConfirmationModalOpen: false,
          modalText: '',
          isLoading: false,
          currentEvent: undefined
        });
      });
  };

  renderAddPlayerToEventModal = () => {
    const { user } = this.props;
    const { isStudentsToAddToEventModalOpen, selectedItems, currentEvent, teams, forms } = this.state;

    const isCurrentEventExist = typeof currentEvent !== 'undefined';
    const events = isCurrentEventExist ? [currentEvent] : selectedItems;

    const tournamentId = this.getTournamentId();
    const isTeamsExist = teams.length > 0;
    const teamId = isTeamsExist ? teams[0].id : '';

    return (
      <SimpleModal
        isOpen={isStudentsToAddToEventModalOpen}
        title="Add students to events"
        customClass="hltStudentAllocationModal"
        dialogStyle={{maxWidth: 720}}
        isBodyBold={false}
        showFooter={false}
        onCloseIconClick={this.closeStudentsToAddToEventModal}
      >
        <StudentsToAddToEventForm
          isSaving={this.state.isSavingAllocations}
          events={events}
          user={user}
          forms={forms}
          teamId={teamId}
          tournamentId={tournamentId}
          addStudentsToEvent={this.addStudentsToEvent}
          onCloseClick={this.closeStudentsToAddToEventModal}
        />
      </SimpleModal>
    );
  };

  openStudentsToAddToEventModal = () => {
    if (this.isReadOnly()) return;
    this.setState({
      isStudentsToAddToEventModalOpen: true
    });
  };

  closeStudentsToAddToEventModal = () => {
    if (this.state.isSavingAllocations) return;
    this.setState({
      isStudentsToAddToEventModalOpen: false,
      currentEvent: undefined,
      selectedItems: []
    });
  };

  renderRemovePlayerFromEventConfirmationModal() {
    const { isRemovePlayerFromEventConfirmationModalOpen, isAskToRemovePlayerFromEvent, modalText } = this.state;

    return (
      <SimpleModal
        isOpen={isRemovePlayerFromEventConfirmationModalOpen}
        title="Confirm the action"
        body={modalText}
        buttonText="Confirm"
        buttonCancelText="Cancel"
        onButtonClick={() => this.removePlayerFromEvent()}
        onCloseClick={this.closeRemovePlayerFromEventConfirmationModal}
      >
        <Checkbox
          customClass="mt-2"
          id="12"
          value={isAskToRemovePlayerFromEvent}
          labelText="Don't ask anymore"
          onChange={() =>
            this.setState(prevState => {
              return {
                isAskToRemovePlayerFromEvent: !prevState.isAskToRemovePlayerFromEvent
              };
            })
          }
        />
      </SimpleModal>
    );
  }

  openRemovePlayerFromEventConfirmationModal = (): void => {
    this.setState({
      isRemovePlayerFromEventConfirmationModalOpen: true
    });
  };

  closeRemovePlayerFromEventConfirmationModal = (): void => {
    this.setState({
      isAskToRemovePlayerFromEvent: false,
      isRemovePlayerFromEventConfirmationModalOpen: false,
      currentEvent: undefined
    });
  };

  renderEditPositionsModal = () => {
    const { isEditPositionsOpen, positionsDraft, positionOptions, isSavingPositions, positionsEvent } = this.state;
    if (!isEditPositionsOpen || !positionsEvent) return null;

    const byName = [...positionsDraft].sort((a, b) => a.name.localeCompare(b.name));

    const onChangeSelect = (playerId: string, value: string) => {
      this.setState(prev => ({
        positionsDraft: prev.positionsDraft.map(p => (p.playerId === playerId ? { ...p, positionId: value } : p))
      }));
    };

    const onChangeCaptain = (playerId: string, checked: boolean) => {
      this.setState(prev => ({
        positionsDraft: prev.positionsDraft.map(p => (p.playerId === playerId ? { ...p, isCaptain: checked } : p))
      }));
    };

    const onChangeSub = (playerId: string, checked: boolean) => {
      this.setState(prev => ({
        positionsDraft: prev.positionsDraft.map(p => (p.playerId === playerId ? { ...p, isSub: checked } : p))
      }));
    };

    const close = () => {
      if (!isSavingPositions) this.setState({isEditPositionsOpen: false, positionsEvent: undefined, positionsDraft: []});
    };
    const eventName = getEventGeneratedName(positionsEvent, {user: this.props.user});
    return <SimpleModal isOpen={isEditPositionsOpen} title="Edit positions"
      customClass="hltStudentAllocationModal hltEditPositionsModal" dialogStyle={{maxWidth: 720}}
      isBodyBold={false} showFooter={false} onCloseIconClick={close}>
      <fieldset className="hltStudentAllocationForm hltEditPositions" disabled={isSavingPositions} aria-busy={isSavingPositions}>
        <div className="hltStudentAllocationForm__content">
          <div className="hltEditPositions__event"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" /></svg><strong>{eventName}</strong></div>
          <p className="hltEditPositions__hint">Set each student's position and mark captains or substitutes.</p>
          <div className="hltEditPositions__students">{byName.map(p => <div key={p.playerId} className="hltEditPositions__row" role="group" aria-label={p.name}>
            <div className="hltEditPositions__student"><strong>{p.name}</strong>{p.schoolName && <small>{p.schoolName}</small>}</div>
            <label className="hltEditPositions__position"><span>Position</span>
              <select aria-label={`Position for ${p.name}`} value={p.positionId} onChange={e => onChangeSelect(p.playerId, e.target.value)}>
                <option value="">No position</option>
                {positionOptions.map(opt => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
              </select>
            </label>
            <div className="hltEditPositions__flags">
              <Switch name={`captain-${p.playerId}`} label="Captain" checked={p.isCaptain} disabled={isSavingPositions} onChange={e => onChangeCaptain(p.playerId, e.target.checked)} />
              <Switch name={`sub-${p.playerId}`} label="Substitute" checked={p.isSub} disabled={isSavingPositions} onChange={e => onChangeSub(p.playerId, e.target.checked)} />
            </div>
          </div>)}</div>
          {!byName.length && <div className="hltStudentAllocationForm__empty">No participants to edit.</div>}
        </div>
        <footer className="hltStudentAllocationForm__footer">
          <span>{byName.length} {byName.length === 1 ? 'student' : 'students'}</span>
          <div><button type="button" className="tnBtn tnBtnSecondary" onClick={close}>Cancel</button>
            <button type="button" className="tnBtn tnBtnPrimary" disabled={isSavingPositions || !byName.length} onClick={this.savePositions}>
              {isSavingPositions ? 'Saving…' : 'Save positions'}
            </button></div>
        </footer>
      </fieldset>
    </SimpleModal>;
  };

  openEditPositions = async (ev: SchoolEvent) => {
    const { user } = this.props;
    this.setState({ isLoading: true });

    try {
      const full = await getSchoolEvent(user, ev.id);
      const schoolId = String(user.activeSchoolId);

      const pos = Array.isArray((full as any)?.sport?.field?.positions)
        ? (full as any).sport.field.positions.map((p: any) => ({
            id: String(p.id || p._id),
            label: p.shortName || p.name
          }))
        : [];
      const teamsData: any[] = ((full as any).teamsData || []) as any[];
      const individualsData: any[] = ((full as any).individualsData || []) as any[];
      const rawPlayers: any[] = ((full as any).players || []) as any[];

      const myTeamIds = new Set<string>();
      for (let i = 0; i < teamsData.length; i++) {
        const t = teamsData[i];
        if (String(t.schoolId) === schoolId) {
          const teamId = String(t.id || t._id);
          myTeamIds.add(teamId);
        }
      }

      const myIndividualKeys = new Set<string>();
      for (let i = 0; i < individualsData.length; i++) {
        const p = individualsData[i];
        if (String(p.schoolId) === schoolId) {
          const uid = String(p.userId || '');
          const pid = String(p.permissionId || '');
          myIndividualKeys.add(uid + '|' + pid);
        }
      }

      const nameByKey = new Map<string, string>();
      const schoolNameByKey = new Map<string, string>();
      const allKnown: any[] = [];

      for (let i = 0; i < teamsData.length; i++) {
        const team = teamsData[i];
        const players = team.players || [];
        for (let j = 0; j < players.length; j++) {
          allKnown.push(players[j]);
        }
      }

      for (let i = 0; i < individualsData.length; i++) {
        allKnown.push(individualsData[i]);
      }

      for (let i = 0; i < allKnown.length; i++) {
        const p = allKnown[i];
        const uid = String(p.userId || '');
        const pid = String(p.permissionId || '');
        const key = uid + '|' + pid;
        if (!key) continue;
        if (p.schoolName || p.school?.name) schoolNameByKey.set(key, p.schoolName || p.school.name);
        if (!nameByKey.has(key)) {
          const display =
            (p.displayName && p.displayName.trim()) ||
            [p.firstName, p.lastName]
              .filter(Boolean)
              .join(' ')
              .trim() ||
            p.name ||
            '';
          if (display) {
            nameByKey.set(key, display);
          }
        }
      }

      const playersSource: any[] = [];
      for (let i = 0; i < rawPlayers.length; i++) {
        const pl = rawPlayers[i];
        const tid = String(pl.teamId || '');
        const uid = String(pl.userId || '');
        const pid = String(pl.permissionId || '');
        const key = uid + '|' + pid;
        const plSchoolId = String(pl.schoolId || '');

        let ok = false;

        if (tid && myTeamIds.has(tid)) {
          ok = true;
        } else if (myIndividualKeys.has(key)) {
          ok = true;
        } else if (plSchoolId && plSchoolId === schoolId) {
          ok = true;
        }

        if (ok) {
          playersSource.push(pl);
        }
      }

      const draft: State['positionsDraft'] = [];
      for (let i = 0; i < playersSource.length; i++) {
        const pl = playersSource[i];
        const uid = String(pl.userId || '');
        const pid = String(pl.permissionId || '');
        const key = uid + '|' + pid;

        const nameFromMap = nameByKey.get(key);
        const fallbackName =
          (pl.displayName && pl.displayName.trim()) ||
          [pl.firstName, pl.lastName]
            .filter(Boolean)
            .join(' ')
            .trim() ||
          pl.name ||
          '—';

        draft.push({
          playerId: String(pl._id),
          userId: uid,
          permissionId: pid || undefined,
          teamId: pl.teamId ? String(pl.teamId) : null,
          name: nameFromMap || fallbackName,
          schoolName: pl.schoolName || pl.school?.name || schoolNameByKey.get(key),
          positionId: pl.positionId ? String(pl.positionId) : '',
          isCaptain: !!pl.isCaptain,
          isSub: !!pl.sub
        });
      }

      this.setState({
        positionsEvent: full,
        positionOptions: pos,
        positionsDraft: draft,
        isEditPositionsOpen: true,
        isLoading: false
      });
    } catch (e) {
      console.error(e);
      this.setState({ isLoading: false });
    }
  };

  savePositions = async () => {
    const { user } = this.props;
    const { positionsEvent, positionsDraft } = this.state;
    if (!positionsEvent) return;

    this.setState({ isSavingPositions: true });

    try {
      const isRelay = !!propz.get(positionsEvent, ['sport', 'isRelay'], false);

      if (isRelay) {
        const byTeam = new Map<string, typeof positionsDraft>();
        for (const p of positionsDraft) {
          const key = String(p.teamId || '');
          if (!byTeam.has(key)) byTeam.set(key, []);
          byTeam.get(key)!.push(p);
        }

        const calls: Array<Promise<any>> = [];
        for (const [teamId, arr] of byTeam.entries()) {
          if (!teamId) continue;
          const update = arr.map(p => ({
            id: p.playerId,
            positionId: p.positionId || null,
            isCaptain: !!p.isCaptain,
            sub: !!p.isSub
          }));

          calls.push(
            updateSchoolEventTeamPlayersBatch(user, positionsEvent.id, teamId, {
              add: [],
              remove: [],
              update
            })
          );
        }
        await Promise.all(calls);
      } else {
        const update = positionsDraft.map(p => ({
          id: p.playerId,
          positionId: p.positionId || null,
          isCaptain: !!p.isCaptain,
          sub: !!p.isSub
        }));

        await updateSchoolEventIndividualsBatch(user, positionsEvent.id, {
          add: [],
          remove: [],
          update
        });
      }

      await this.setItems();
      this.setState({
        isEditPositionsOpen: false,
        positionsEvent: undefined,
        positionsDraft: [],
        isSavingPositions: false
      });
    } catch (e) {
      console.error(e);
      this.setState({ isSavingPositions: false });
    }
  };

  isReadOnly = () => Boolean(this.props.participationReadOnly || this.state.tournament?.isReadOnly);

  renderEventActions = (event: SchoolEvent) => {
    const readOnly = this.isReadOnly();
    const positions = (event as any)?.sport?.field?.positions || (event as any)?.sport?.positions || [];
    const canEditPositions = String(event.sport?.players).toUpperCase() === 'TEAM' && event.players?.length > 0 && positions.length > 0;
    return <td className="hltParticipantEvents__actions" onClick={e => e.stopPropagation()}>
      {!readOnly && <><button type="button" className="eDsButton eDsButton--secondary" aria-label={`Add participants to ${getEventGeneratedName(event, {user: this.props.user})}`}
        onClick={() => this.onCellIconClick({currentEvent: event}, CELL_ACTION_ICON.ADD_TO_EVENT)}><span aria-hidden="true">+</span> Add participants</button>
        {canEditPositions && <button type="button" className="eDsButton eDsButton--secondary" onClick={() => this.onCellIconClick({currentEvent: event}, CELL_ACTION_ICON.EDIT_POSITIONS)}>Edit positions</button>}</>}
    </td>;
  };

  renderGrid() {
    const {
      items,
      allEvents,
      forms,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isSelectAllChecked,
      currentPage,
      total,
      tournament
    } = this.state;
    const { user } = this.props;

    const eventsSports = allEvents.map(event => event.sport);
    const ageGroupsNaming = propz.get(user, ['activeSchool', 'ageGroupsNaming'], '');

    const actionItems = [
      {
        itemText: 'Add participants',
        onItemClick: this.openStudentsToAddToEventModal,
        isActive: selectedItems.length > 0 && !this.isReadOnly()
      }
    ];

    const filterOptions = {
      eventSport: getSelectOptionForSport(eventsSports),
      eventAges: getSelectOptionForAge(forms, ageGroupsNaming),
      gender: getSelectOptionForTournamentEventGender()
    };

    const columns: ColumnDefinition[] = [...COLUMNS, {
      text: 'Entry capacity', field: 'capacity', isSort: false, type: FILTER_TYPE.NONE,
      cell: (event: SchoolEvent) => {
        const own = String(this.props.user.activeSchoolId);
        const teams = (event.teamsData || []).filter(team => String(team.schoolId) === own);
        const players = [...(event.individualsData || event.players || []).filter(player => String(player.schoolId) === own), ...teams.reduce((rows, team) => rows.concat(team.players || []), [])];
        const count = new Set(players.map(player => String(player.userId))).size;
        const max = tournament?.isEventParticipantLimitEnforced === false ? 0 : Number(propz.get(event, ['sport', 'defaultLimits', 'maxPlayers'], 0));
        return <td><strong>{count} / {max || '∞'}</strong><small>{max && count >= max ? 'Full · replace to add another' : max ? `${Math.max(0, max - count)} places available` : 'No sport limit'}</small></td>;
      }
    }, {
      text: 'Your participants', field: 'participants', isSort: false, type: FILTER_TYPE.NONE,
      cell: (event: SchoolEvent) => <EventParticipants user={user} event={event} onClick={this.onCellIconClick} showPositions maxVisible={3} modern readOnly={this.isReadOnly()} />
    }];
    if (!this.isReadOnly()) columns.push({text: 'Actions', field: 'actions', isSort: false, type: FILTER_TYPE.NONE, cell: this.renderEventActions});

    return (
      <Grid2
        dataItems={items}
        filters={filters}
        currentPage={currentPage}
        total={total}
        isSelectAllChecked={isSelectAllChecked}
        isDataFiltered={isDataFiltered}
        sortDirection={sortDirection}
        sortColumnsName={sortColumnsName}
        isShowFilter={isShowFilter}
        dataItemsSelected={selectedItems}
        columns={columns}
        actionItems={actionItems}
        options={filterOptions}
        onItemClick={this.onItemClick}
        onCellIconClick={this.onCellIconClick}
        onSortClick={this.onTableSortClick}
        onApplyFilterClick={this.onApplyFilterClick}
        onClearFilterClick={this.onClearFilterClick}
        onCancelFilterClick={this.onCancelFilterClick}
        onTableFilterChange={this.onTableFilterChange}
        onTableFilterClick={this.onTableFilterClick}
        setCurrentPageParams={this.setCurrentPageParams}
        onSelectAllClick={this.onSelectAllClick}
        onSelectAllOnPageClick={this.onSelectAllOnPageClick}
        onUnselectAllClick={this.onUnselectAllClick}
        gridTitle="Events"
        gridTitleCount={total}
        isActionsInline
        selectionActionsBelow
        showClearSelection
        isSelectionHidden={this.isReadOnly()}
        isSelectDisabled={this.isReadOnly()}
        isCSV={false}
        columnVisibilityKey="union-high-level-tournament-events"
        fixedColumnFields={['eventName', 'participants']}
        emptyText="No tournament events yet"
        emptyHint="Events will appear here when the organiser adds them."
        emptyFilteredText="No events match your filters"
        emptyFilteredHint="Try changing or clearing the filters."
        stylizeCell={({column}) => `hltParticipantEvents__cell--${column.field}`}
        user={user}
      />
    );
  }

  render() {
    const { isLoading, total } = this.state;

    if (isLoading && !this.state.isSavingAllocations && !this.state.isSavingPositions) {
      return <Loader />;
    }

    return (
      <section className="schoolInvitesList hltParticipantEvents" aria-label="Tournament events" aria-busy={this.state.isSavingAllocations}>
        {this.state.isSavingAllocations && <div className="hltAllocationSaving" role="status"><Loader /><strong>Saving allocations…</strong></div>}
        <header className="hltParticipantEvents__heading"><h2>Events <span>{total.toLocaleString()}</span></h2>
          <p>{this.isReadOnly() ? 'View your students and their event assignments. This tournament is read-only.' : 'Add students from your squad to an event, or select several events to assign participants together.'}</p></header>
        {this.renderAddPlayerToEventModal()}
        {this.renderRemovePlayerFromEventConfirmationModal()}
        {this.renderEditPositionsModal()}

        {this.renderGrid()}
      </section>
    );
  }
}

